/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AccountingAccountRestService } from './accounting-accounts';
import { AccountingWipRestService } from './accounting-wip';
import { AelRestService } from './ael';
import { AuthNumberRestService } from './auth-numbers';
import { BaseDesignRestService } from './base-design';
import { BulkDeleteRestService } from './bulk-delete';
import { BulkUpdateRestService } from './bulk-update';
import { CalendarRestService } from './calendar';
import { CashFlowForecastRestService } from './cash-flow-forecast';
import { CommunicationRestService } from './communications';
import { CommunityRestService } from './communities';
import { ChecklistRestService } from './complete-sales';
import { ComponentItemFinderRestService, ComponentRestService } from './components';
import { ContactRestService } from './contacts';
import { CostCenterRestService } from './cost-centers';
import { CriticalPathRestService } from './critical-path';
import { CsMasterRestService } from './cs-master';
import { CustomFieldRestService } from './custom-fields';
import { DashboardsRestService } from './dashboards';
import { DrawRuleRestService } from './draw-rules';
import { EDocRestService } from './e-docs';
import { EmailCampaignRestService } from './email-campaigns';
import { EmailRecipientRestService } from './email-recipients';
import { EmailTemplateRestService } from './email-templates';
import { EomReportRestService } from './eom-reports';
import { ExportOfficeRestService } from './export-office';
import { ExportPricesRestService } from './export-prices';
import { FormulaRestService } from './formula';
import { FranchiseMonthlyRestService } from './franchise-monthly';
import {
  GraphicalTakeOffHousePlanViewRestService,
  GraphicalTakeOffPictureRestService,
  GraphicalTakeOffTopRestService,
} from './graphical-take-off';
import { HelpRestService } from './help';
import { HousePlanEstimateRestService, HousePlanRestService } from './house-plans';
import { ImportLeadsRestService } from './import-leads';
import { ImportPriceItemsRestService } from './import-price-items';
import { ItemRestService } from './items';
import { JasperCommercialRestService } from './jasper-commercial';
import { JobLettersRestService } from './job-letters';
import { JobSpecRestService } from './job-spec';
import { JobSpecTemplateRestService } from './job-spec-templates';
import { JobStageRestService } from './job-stages';
import {
  JobChangeOrderRestService,
  JobChecklistsRestService,
  JobColorSelectionRestService,
  JobCommunicationRestService,
  JobDatesRestService,
  JobDrawsRestService,
  JobEDocRestService,
  JobEstimateRestService,
  JobFinancialsRestService,
  JobGeneralInfoRestService,
  JobInsuranceRestService,
  JobLetterDocRestService,
  JobOrderRestService,
  JobRestService,
  JobRfqRestService,
  JobSharedDocRestService,
  JobWarrantyRestService,
} from './jobs';

import {
  ActivityRestService,
  HlpRestService,
  LeadBoardRestService,
  LeadRestService,
  MeetingRestService,
  QuotationRestService,
  SalesFolderEDocRestService,
  SalesFolderRestService,
  SiteRestService,
} from './leads';
import { LetterTemplateRestService } from './letter-templates';
import { LetterRestService } from './letters';
import { LicenseAgreementRestService } from './license-agreements';
import { LocationRestService } from './locations';
import { MasterZoneModulePermissionTreeRestService, MasterZoneRestService } from './master-zones';
import { MilestoneEventRestService } from './milestone-events';
import { OfficeRolePermissionTreeRestService, OfficeRoleRestService } from './office-roles';
import { OfficeRestService } from './offices';
import { SubOfficeRestService } from './sub-offices';

import { PriceBookRestService } from './price-book';
import { PrinterRestService } from './printers';
import { BuilderUserProfileRestService } from './profiles';
import { ReportSettingsRestService } from './report-settings';
import { ReportRestService } from './reports';
import { RfqStructureRestService } from './rfq-structure';
import { SalesTaxRatesRestService } from './sales-tax-rates';
import { SalespersonBudgetRestService } from './salesperson-budgets';
import { ScheduleTemplateRestService } from './schedule-templates';
import {
  ConstructionScheduleRestService,
  MaintenanceScheduleRestService,
  PreConstructionScheduleRestService,
  SalesScheduleRestService,
  ScheduleTaskNotesBusinessService,
} from './schedules';
import { SchedulingSuppliersRestService } from './scheduling-suppliers';
import { SmsTemplateRestService } from './sms-templates';
import { StlRestService } from './stl';
import { SystemVarsRestService } from './system-vars';
import { SystemVarsEstimatingRestService } from './system-vars-estimating';
import { SystemVarsSalesRestService } from './system-vars-sales';
import { TakeOffParamsRestService } from './take-off-params';
import { TaxRateRestService } from './tax-rates';
import { UomRestService } from './uom';
import { UsageRestService } from './usage';
import { UserRestService } from './users';
import { VersionRestService } from './version';
import { XeroIssueLogRestService } from './xero-issue-log';
import { XeroSyncRestService } from './xero-sync';
import { CareerEnquiriesRestService } from './career-enquiries';
import { FeeExclusionRestService } from './fee-exclusions';
import { MobileChecklistsRestService } from './mobile-checklists';

export const DATA_SERVICES = [
  AelRestService,
  AuthNumberRestService,
  CommunityRestService,
  ChecklistRestService,
  MobileChecklistsRestService,
  ContactRestService,
  LocationRestService,
  MasterZoneRestService,
  OfficeRoleRestService,
  OfficeRolePermissionTreeRestService,
  OfficeRestService,
  SubOfficeRestService,
  MasterZoneModulePermissionTreeRestService,
  BuilderUserProfileRestService,
  UserRestService,
  VersionRestService,
  CustomFieldRestService,
  SystemVarsRestService,
  HelpRestService,
  UomRestService,
  TakeOffParamsRestService,
  HousePlanRestService,
  HousePlanEstimateRestService,
  SalesTaxRatesRestService,
  SystemVarsEstimatingRestService,
  SystemVarsSalesRestService,
  PriceBookRestService,

  EmailTemplateRestService,
  CostCenterRestService,
  ItemRestService,
  ExportPricesRestService,
  ComponentRestService,
  FeeExclusionRestService,
  ComponentItemFinderRestService,
  BulkUpdateRestService,
  BulkDeleteRestService,
  UsageRestService,
  StlRestService,
  ExportOfficeRestService,
  JobLettersRestService,
  CommunicationRestService,
  LeadRestService,
  SalesFolderRestService,
  LeadBoardRestService,
  MeetingRestService,
  LetterRestService,
  SiteRestService,
  QuotationRestService,
  SalespersonBudgetRestService,
  ScheduleTemplateRestService,
  SchedulingSuppliersRestService,
  ImportLeadsRestService,
  RfqStructureRestService,
  ImportPriceItemsRestService,
  LetterTemplateRestService,
  GraphicalTakeOffHousePlanViewRestService,
  GraphicalTakeOffPictureRestService,
  GraphicalTakeOffTopRestService,
  JobSpecTemplateRestService,
  JobRestService,
  JobEstimateRestService,
  JobColorSelectionRestService,
  CsMasterRestService,
  JobSpecTemplateRestService,
  JobStageRestService,
  JobSpecRestService,
  JobOrderRestService,
  EmailRecipientRestService,
  JobWarrantyRestService,
  JobGeneralInfoRestService,
  PrinterRestService,
  JobDatesRestService,
  JobRfqRestService,
  JobLetterDocRestService,
  JobChecklistsRestService,
  JobChangeOrderRestService,
  JobInsuranceRestService,
  JobCommunicationRestService,
  JobEDocRestService,
  JobDrawsRestService,
  JobSharedDocRestService,
  JobFinancialsRestService,
  ReportRestService,
  FormulaRestService,
  DrawRuleRestService,
  CalendarRestService,
  CriticalPathRestService,
  ConstructionScheduleRestService,
  PreConstructionScheduleRestService,
  MaintenanceScheduleRestService,
  SalesScheduleRestService,
  SalesFolderEDocRestService,
  EDocRestService,
  TaxRateRestService,
  XeroIssueLogRestService,
  AccountingAccountRestService,
  MilestoneEventRestService,
  EmailCampaignRestService,
  DashboardsRestService,
  CashFlowForecastRestService,
  AccountingWipRestService,
  FranchiseMonthlyRestService,
  EomReportRestService,
  SmsTemplateRestService,
  BaseDesignRestService,
  ActivityRestService,
  LicenseAgreementRestService,
  ReportSettingsRestService,
  JasperCommercialRestService,
  XeroSyncRestService,
  CareerEnquiriesRestService,
  HlpRestService,
  ScheduleTaskNotesBusinessService,
];
